module.exports = __webpack_public_path__ + "static/media/business-desk.d4c14773.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/business-desk.jpg
// module id = 1089
// module chunks = 0